(() => {
  let opener = null;
  let previousOverflow = '';
  let previousPadding = '';
  let restoreFocus = true;
  let closeTimer = null;
  const closeMenu = (dialog, options = {}) => {
    if (!dialog?.open) return;
    restoreFocus = options.restoreFocus !== false;
    const finish = () => {
      delete dialog.dataset.closing;
      if (dialog.open) dialog.close();
    };
    if (options.immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.clearTimeout(closeTimer);
      // Unlock before the browser follows an anchor or navigates.
      document.body.style.overflow = previousOverflow;
      document.body.style.paddingRight = previousPadding;
      finish();
      return;
    }
    if (dialog.dataset.closing) return;
    dialog.dataset.closing = 'true';
    closeTimer = window.setTimeout(finish, 200);
  };
  const initialize = root => {
    root.querySelectorAll('.faq > button').forEach(button => {
      if (button.dataset.cbReady) return;
      button.dataset.cbReady = 'true';
      button.addEventListener('click', () => {
        const open = button.getAttribute('aria-expanded') !== 'true';
        button.closest('.faq-list').querySelectorAll('.faq > button').forEach(item => {
          const active = open && item === button;
          item.setAttribute('aria-expanded', String(active));
          const panel = document.getElementById(item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !active;
          const icon = item.querySelector('svg');
          if (icon) icon.innerHTML = active ? '<path d="M5 12h14"/>' : '<path d="M12 5v14M5 12h14"/>';
        });
      });
    });
    root.querySelectorAll('.mobile-menu').forEach(button => {
      if (button.dataset.cbReady) return;
      button.dataset.cbReady = 'true';
      button.setAttribute('aria-haspopup', 'dialog');
      button.addEventListener('click', () => {
        const dialog = document.querySelector('.cb-menu-shell');
        if (!dialog || dialog.open) return;
        opener = button;
        restoreFocus = true;
        button.setAttribute('aria-expanded', 'true');
        previousOverflow = document.body.style.overflow;
        previousPadding = document.body.style.paddingRight;
        const scrollbar = window.innerWidth - document.documentElement.clientWidth;
        if (scrollbar > 0) document.body.style.paddingRight = `${parseFloat(getComputedStyle(document.body).paddingRight) + scrollbar}px`;
        document.body.style.overflow = 'hidden';
        dialog.showModal();
        dialog.querySelector('.mobile-close')?.focus({ preventScroll: true });
      });
    });
    root.querySelectorAll('.cb-menu-shell').forEach(dialog => {
      if (dialog.dataset.cbReady) return;
      dialog.dataset.cbReady = 'true';
      dialog.addEventListener('cancel', event => { event.preventDefault(); closeMenu(dialog); });
      dialog.addEventListener('close', () => {
        document.body.style.overflow = previousOverflow;
        document.body.style.paddingRight = previousPadding;
        if (opener?.isConnected) {
          opener.setAttribute('aria-expanded', 'false');
          if (restoreFocus) opener.focus({ preventScroll: true });
        }
      });
      dialog.addEventListener('click', event => {
        if (event.target.closest('a')) {
          closeMenu(dialog, { immediate: true, restoreFocus: false });
        } else if (event.target === dialog || event.target.closest('.mobile-close')) {
          closeMenu(dialog);
        }
      });
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const dialog = event.target.querySelector('.cb-menu-shell');
    if (dialog?.open) closeMenu(dialog);
  });
})();
